"use client"

import { Target, Heart, Globe, Users } from "lucide-react"

export const AboutMission = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center border-t-4 border-b-4 border-gray-900 py-6 mb-12 animate-in fade-in duration-700">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">What Drives Us</h2>
          <div className="text-sm text-gray-600 uppercase tracking-widest mt-2">Our Core Values & Commitments</div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {/* Mission */}
          <div className="p-6 sm:p-8 bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-amber-200 hover:border-amber-400 animate-in slide-in-from-left duration-700">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 bg-gradient-to-br from-amber-600 to-rust-700 p-4 rounded-lg shadow-md">
                <Target className="w-8 h-8 text-white" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Our Mission</h3>
                <p className="text-gray-700 leading-relaxed">
                  To make world-class travel experiences accessible to every Filipino, creating memories that last a
                  lifetime through exceptional service and unbeatable value.
                </p>
              </div>
            </div>
          </div>

          {/* Vision */}
          <div className="p-6 sm:p-8 bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-amber-200 hover:border-amber-400 animate-in slide-in-from-right duration-700" style={{ animationDelay: '100ms' }}>
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 bg-gradient-to-br from-amber-600 to-rust-700 p-4 rounded-lg shadow-md">
                <Heart className="w-8 h-8 text-white" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Our Vision</h3>
                <p className="text-gray-700 leading-relaxed">
                  To be the Philippines' leading travel company, recognized for innovation, reliability, and our
                  unwavering commitment to customer satisfaction.
                </p>
              </div>
            </div>
          </div>

          {/* Values */}
          <div className="p-6 sm:p-8 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-gray-200 hover:border-gray-300 animate-in slide-in-from-left duration-700" style={{ animationDelay: '200ms' }}>
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 bg-gradient-to-br from-gray-900 to-gray-800 p-4 rounded-lg shadow-md">
                <Globe className="w-8 h-8 text-amber-600" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Our Values</h3>
                <p className="text-gray-700 leading-relaxed">
                  Integrity, excellence, and passion drive everything we do. We believe in honest pricing, quality
                  service, and creating genuine connections with our travelers.
                </p>
              </div>
            </div>
          </div>

          {/* Promise */}
          <div className="p-6 sm:p-8 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-gray-200 hover:border-gray-300 animate-in slide-in-from-right duration-700" style={{ animationDelay: '300ms' }}>
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 bg-gradient-to-br from-gray-900 to-gray-800 p-4 rounded-lg shadow-md">
                <Users className="w-8 h-8 text-amber-600" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">Our Promise</h3>
                <p className="text-gray-700 leading-relaxed">
                  Every trip is crafted with care, every detail is handled with precision, and every traveler is treated
                  like family. Your dream vacation is our commitment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
